import React, { useEffect } from "react";
import Header from "../components/Header.js";
import WalletSideMenu from "../components/WalletSideMenu";
import WalletBalance from "../components/WalletBalance";
import DepositWalletIndian from "../components/DepositWalletIndian";
import Footer from "../components/Footer.js";


// Scroll to Top
function ScrollToTopOnMount() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return null;
}


export default function WalletDeposit() {

  return (
<main>
	 <ScrollToTopOnMount />
          <Header />
          <div className="page-content">
            <div className="container">
              <div className="row">
                <div className="col-lg-4">
                  <WalletSideMenu />
                  <DepositWalletIndian />
                </div>
                <div className="col-lg-8">
                  <WalletBalance />
                  <div className="userContent mt-4">
                    <div className="flexTitle">
                      <h2>History</h2>
                      <select className="form-select filterSelect">
                        <option selected>Today</option>
                        <option value="1">Last week</option>
                        <option value="2">Last 1 month</option>
                        <option value="3">Last year</option>
                      </select>
                    </div>
                    <div class="table-responsive">
                    <div class="table-responsive">
                      <table class="table table-bordered customTable">
                        <tr>
                          <th>Date</th>
                          <th>Payment Type</th>
                          <th>Transaction ID</th>
                          <th>Amount (INR)</th>
                          <th>Status</th>
                        </tr>
                        <tr>
                          <td>06-09-2022  16:22</td>
                          <td>Bank Transfer</td>
                          <td>TRX125006</td>
                          <td>1357.25</td>
                          <td className="greenText">Completed</td>
                        </tr>
                        <tr>
                          <td>06-09-2022  16:22</td>
                          <td>UPI</td>
                          <td>TRX125006</td>
                          <td>47895.36</td>
                          <td className="yellowText">Pending</td>
                        </tr>
                        <tr>
                          <td>06-09-2022  16:22</td>
                          <td>Wallet</td>
                          <td>TRX125006</td>
                          <td>236.47</td>
                          <td className="greenText">Completed</td>
                        </tr>
                        <tr>
                          <td>06-09-2022  16:22</td>
                          <td>Bank Transfer</td>
                          <td>TRX125006</td>
                          <td>67895.10</td>
                          <td className="yellowText">Pending</td>
                        </tr>
                        <tr>
                          <td>06-09-2022  16:22</td>
                          <td>Bank Transfer</td>
                          <td>TRX125006</td>
                          <td>1357.25</td>
                          <td className="greenText">Completed</td>
                        </tr>
                        <tr>
                          <td>06-09-2022  16:22</td>
                          <td>Bank Transfer</td>
                          <td>TRX125006</td>
                          <td>47895.36</td>
                          <td className="redText">Rejected</td>
                        </tr>
                        <tr>
                          <td>06-09-2022  16:22</td>
                          <td>Bank Transfer</td>
                          <td>TRX125006</td>
                          <td>236.47</td>
                          <td className="greenText">Completed</td>
                        </tr>
                        <tr>
                          <td>06-09-2022  16:22</td>
                          <td>Bank Transfer</td>
                          <td>TRX125006</td>
                          <td>67895.10</td>
                          <td className="redText">Rejected</td>
                        </tr>
                      </table>
                    </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
    </main>

  );
}
